import "../../../scss/common.scss";
import "./myCompany.scss";
import { Grid, Box, Divider } from "@mui/material";
import check from "../../../assets/setting/mycompany/check1.png";
import uncheck from "../../../assets/setting/mycompany/uncheck1.png";
import invoiceImg from "../../../assets/setting/mycompany/invoice.png";
import { billingContact } from "../../../mock-data/my-company-invoice-mock-data";
import { useState } from "react";
import Invoice from "./Invoice/invoice";
import ActionHeader from "../../../UI/action-header/action-header";
import editt from "../../../assets/setting/mycompany/editt.png";

const MyCompany = () => {
  const [invoice, setInvoice] = useState(false);
  const [address, setAddress] = useState(false);
  const [cardDetail, setCardDetail] = useState(false);
  const [textAreaInput, setTextAreaInput] = useState('');

  return (
    <>
      {!invoice && (
        <div>
          <Box sx={{ mb: 4 }}>
            <ActionHeader heading="My Company" />
          </Box>
          <div className="myCompany br-10">
            {/* company information  */}
            <Grid container>
              <Grid item md={3} xs={12}>
                <h4 className="heading4 h4 fw-600">Company Information</h4>
              </Grid>
              <Grid item md={4.5} xs={12}>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">
                    Account Owner <span>*</span>
                  </label>
                  <input
                    className="input br-5"
                    type="text"
                    name="owner"
                    disabled
                    placeholder="Andrew Joseph"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">
                    Company Name <span>*</span>
                  </label>
                  <input
                    className="input br-5"
                    type="text"
                    name="company"
                    disabled
                    placeholder="Orcalo"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">
                    Email <span>*</span>
                  </label>
                  <input
                    className="input br-5"
                    type="email"
                    name="email"
                    disabled
                    placeholder="Andrew.J@Gmail.Com"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">
                    Phone <span>*</span>
                  </label>
                  <input
                    className="input br-5"
                    type="number"
                    name="phone"
                    disabled
                    placeholder="020 7946 0000"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">Registration Number</label>
                  <input
                    className="input br-5"
                    type="number"
                    name="registrationNo"
                    placeholder="01234567"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">Incorporation Date</label>
                  <input className="input br-5" type="date" name="date" />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">
                    Company URL <span>*</span>
                  </label>
                  <input
                    className="input br-5"
                    type="email"
                    name="URL"
                    disabled
                    placeholder="www.buzzhr.com"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">Default Currency</label>
                  <input
                    className="input br-5"
                    type="email"
                    name="currency"
                    disabled
                    placeholder="£"
                  />
                </Box>
              </Grid>
            </Grid>
            <Divider sx={{ border: "1px solid #CCCCCC", marginTop: "40px" }} />
            {/* billing information  */}
            <Grid container>
              <Grid item md={3} xs={12}>
                <h4 className="heading4 h4 fw-600">Billing Information</h4>
              </Grid>
              <Grid item md={4.5} xs={12}>
                <Box display="flex" justifyContent="space-between">
                  <label className="fw-500">Billing Address</label>
                  <div className="icon">
                    <img
                      src={check}
                      alt="icon"
                      style={{ paddingRight: "10px" }}
                      onClick={() => setAddress(!address)}
                    />
                    <img src={uncheck} alt="icon" onClick={() => setAddress(true)} />
                  </div>
                </Box>
                <textarea onChange={(e) => setTextAreaInput(e.target.value)}></textarea>
                {address && <Grid item md={5}>
                  <Box display='flex' justifyContent='space-between'>
                    <p className="fs-14 fw-500 lh-22" style={{ color: '#14142B' }}>Billing address</p>
                    <img src={editt} alt='edit' />
                  </Box>
                  <p className="fs-16 fw-500 lh-24" style={{ color: '#A0A3BD' }}>4 Roundwood Avenue #82 Hayes, Uxbridge, UB11 1AF Uk</p>
                </Grid>}
              </Grid>
            </Grid>
            <Divider sx={{ border: "1px solid #CCCCCC", marginTop: "40px" }} />
            {/* card details  */}
            <Grid container>
              <Grid item md={3} xs={12}>
                <h4 className="heading4 h4 fw-600">Card Details</h4>
              </Grid>
              <Grid item md={4.5} xs={12}>
                <Box>
                  <Box display="flex" justifyContent="space-between">
                    <label className="fw-500">Cardholder name</label>
                    <div className="icon">
                      <img
                        src={check}
                        alt="icon"
                        style={{ paddingRight: "10px" }}
                      />
                      <img src={uncheck} alt="icon" />
                    </div>
                  </Box>
                </Box>
                <input className="input br-5" style={{ width: "100%" }} />
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">Card Number</label>
                  <input className="input br-5" type="text" name="cardNo" />
                </Box>
                <Box display="flex" flexDirection="column">
                  <label className="fw-500">Expiry Date</label>
                  <input className="input br-5" type="date" name="date" />
                </Box>
                {cardDetail && <Grid item lg={8} md={10} sm={6} xs={12} display='flex' justifyContent='space-between'>
                  <Box>
                    <p className="fs-14 fw-500 lh-22" style={{ color: "#14142B", paddingBottom: '10px' }}>Cardholder name</p>
                    <p className="fs-14 fw-500 lh-22" style={{ color: "#14142B", paddingBottom: '10px' }}>Card Number</p>
                    <p className="fs-14 fw-500 lh-22" style={{ color: "#14142B", paddingBottom: '10px' }}>Expiry Date</p>
                  </Box>
                  <Box>
                    <p className="fs-16 fw-500 lh-24" style={{ color: "#A0A3BD", paddingBottom: '10px' }}>Andrew joseph</p>
                    <p className="fs-16 fw-500 lh-24" style={{ color: "#A0A3BD", paddingBottom: '10px' }}>(702) 555-0122</p>
                    <p className="fs-16 fw-500 lh-24" style={{ color: "#A0A3BD", paddingBottom: '10px' }}>12/12/2023</p>
                  </Box>
                  <Box>
                    <img src={editt} alt='editt' className='cursor-pointer' />
                  </Box>
                </Grid>}
              </Grid>
            </Grid>
            <Divider sx={{ border: "1px solid #CCCCCC", marginTop: "40px" }} />
            {/* billing center  */}
            <Grid container>
              <Grid item md={3} xs={12}>
                <h4 className="heading4 h4 fw-600">Billing Center</h4>
              </Grid>
              <Grid
                item
                md={4.5}
                sm={12}
                display="flex"
                justifyContent="space-between"
                flexWrap='wrap'
                pt="40px"
              >
                <Grid item lg={8} md={6} sm={12} xs={12}>
                  <Box className="billCard br-10">
                    <p className="h2 fw-600 billAmount">£1080.01</p>
                    <p className="h7 fw-500 daysleft">5 Days Left</p>
                    <Box display="flex" justifyContent="end">
                      <button className="btn btn-secondary">
                        Update Payment
                      </button>
                    </Box>
                  </Box>
                </Grid>
                <Grid item lg={3.5} md={6} sm={12} xs={12}>
                  <Box
                    className="invoiceHistory br-10"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    onClick={() => setInvoice(true)}
                  >
                    <img src={invoiceImg} alt="icon" />
                    <p className="invoiceTag fw-600">Invoice History</p>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Divider sx={{ border: "1px solid #CCCCCC", marginTop: "40px" }} />
            {/* billing contacts  */}
            <Grid container display="flex">
              <Grid item md={3} sm={12}>
                <h4 className="heading4 h4 fw-600">Billing Contacts</h4>
              </Grid>

              <Grid display="flex" justifyContent={{ md: "space-between", sm: "center" }} item lg={4} md={6} sm={12} xs={12} flexWrap="wrap">
                {billingContact.map((e, index) => {
                  return (
                    <>
                      <Box
                        className="contact"
                        display="flex"
                        flexWrap="wrap"
                        key={index}
                      >
                        <img src={e.image} alt="icon" className="icon" />
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          sx={{ pl: "10px", pt: "20px" }}
                        >
                          <p className="contactName fw-500">{e.name}</p>
                          <p className="contactDes fs-16 fw-500 lh-24">
                            {e.role}
                          </p>
                        </Box>
                      </Box>
                    </>
                  );
                })}
              </Grid>
            </Grid>
            <Grid
              container
              className="btns"
              display="flex"
              justifyContent="flex-end"
            >
              <Grid item>
                <Box>
                  <button className="cancel btn btn-light-grey">Cancel</button>
                  <button className="cancel save btn btn-secondary">Save</button>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>

      )
      }
      {invoice && <Invoice />}

    </>
  );
};
export default MyCompany;
